import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_ART_Articulos_Reservables_Listar = async () => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_Reservables/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Leer = async (CodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_Reservables/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Generar_JSONBasico = async (codigoArticulo, intervaloMinimoMinutos, 
    lunesDisponible, lunesCantidadMaxima, lunesHoraDesde, lunesHoraHasta, 
    martesDisponible, martesCantidadMaxima, martesHoraDesde, martesHoraHasta, 
    miercolesDisponible, miercolesCantidadMaxima, miercolesHoraDesde, miercolesHoraHasta, 
    juevesDisponible, juevesCantidadMaxima, juevesHoraDesde, juevesHoraHasta, 
    viernesDisponible, viernesCantidadMaxima, viernesHoraDesde, viernesHoraHasta, 
    sabadoDisponible, sabadoCantidadMaxima, sabadoHoraDesde, sabadoHoraHasta, 
    domingoDisponible, domingoCantidadMaxima, domingoHoraDesde, domingoHoraHasta, 
    imagen, cantidadesVisiblesEnWeb, disponibleWeb, sumaParticipantesACodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Generar_JSONBasico";

    try {

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoArticulo: codigoArticulo, 
            IntervaloMinimoMinutos: intervaloMinimoMinutos, 
            LunesDisponible: lunesDisponible, 
            LunesCantidadMaxima: lunesCantidadMaxima, 
            LunesHoraDesde: lunesHoraDesde, 
            LunesHoraHasta: lunesHoraHasta, 
            MartesDisponible: martesDisponible, 
            MartesCantidadMaxima: martesCantidadMaxima, 
            MartesHoraDesde: martesHoraDesde, 
            MartesHoraHasta: martesHoraHasta, 
            MiercolesDisponible: miercolesDisponible, 
            MiercolesCantidadMaxima: miercolesCantidadMaxima, 
            MiercolesHoraDesde: miercolesHoraDesde, 
            MiercolesHoraHasta: miercolesHoraHasta, 
            JuevesDisponible: juevesDisponible, 
            JuevesCantidadMaxima: juevesCantidadMaxima, 
            JuevesHoraDesde: juevesHoraDesde, 
            JuevesHoraHasta: juevesHoraHasta, 
            ViernesDisponible: viernesDisponible, 
            ViernesCantidadMaxima: viernesCantidadMaxima, 
            ViernesHoraDesde: viernesHoraDesde, 
            ViernesHoraHasta: viernesHoraHasta, 
            SabadoDisponible: sabadoDisponible, 
            SabadoCantidadMaxima: sabadoCantidadMaxima, 
            SabadoHoraDesde: sabadoHoraDesde, 
            SabadoHoraHasta: sabadoHoraHasta, 
            DomingoDisponible: domingoDisponible, 
            DomingoCantidadMaxima: domingoCantidadMaxima, 
            DomingoHoraDesde: domingoHoraDesde, 
            DomingoHoraHasta: domingoHoraHasta, 
            Imagen: imagen, 
            CantidadesVisiblesEnWeb: cantidadesVisiblesEnWeb, 
            DisponibleWeb: disponibleWeb, 
            SumaParticipantesACodigoArticulo: sumaParticipantesACodigoArticulo
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Modificar = async (codigoArticulo, intervaloMinimoMinutos, 
    lunesDisponible, lunesCantidadMaxima, lunesHoraDesde, lunesHoraHasta, 
    martesDisponible, martesCantidadMaxima, martesHoraDesde, martesHoraHasta, 
    miercolesDisponible, miercolesCantidadMaxima, miercolesHoraDesde, miercolesHoraHasta, 
    juevesDisponible, juevesCantidadMaxima, juevesHoraDesde, juevesHoraHasta, 
    viernesDisponible, viernesCantidadMaxima, viernesHoraDesde, viernesHoraHasta, 
    sabadoDisponible, sabadoCantidadMaxima, sabadoHoraDesde, sabadoHoraHasta, 
    domingoDisponible, domingoCantidadMaxima, domingoHoraDesde, domingoHoraHasta, 
    imagen, cantidadesVisiblesEnWeb, disponibleWeb, sumaParticipantesACodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Insertar";

    try {
        
        await llamadaAPI_PUT("ABM_ART_Articulos_Reservables/ModificarCompleto/", await function_ABM_ART_Articulos_Reservables_Generar_JSONBasico(codigoArticulo, intervaloMinimoMinutos, 
            lunesDisponible, lunesCantidadMaxima, lunesHoraDesde, lunesHoraHasta, 
            martesDisponible, martesCantidadMaxima, martesHoraDesde, martesHoraHasta, 
            miercolesDisponible, miercolesCantidadMaxima, miercolesHoraDesde, miercolesHoraHasta, 
            juevesDisponible, juevesCantidadMaxima, juevesHoraDesde, juevesHoraHasta, 
            viernesDisponible, viernesCantidadMaxima, viernesHoraDesde, viernesHoraHasta, 
            sabadoDisponible, sabadoCantidadMaxima, sabadoHoraDesde, sabadoHoraHasta, 
            domingoDisponible, domingoCantidadMaxima, domingoHoraDesde, domingoHoraHasta, 
            imagen, cantidadesVisiblesEnWeb, disponibleWeb, sumaParticipantesACodigoArticulo));

        return 1;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

/*
router.get("/API/ABM_ART_Articulos_Reservables/Leer/:CodigoCompania/:CodigoEmpresa/:CodigoPlanta/:CodigoArticulo", ABM_ART_Articulos_Reservables_Leer)
//NEFTIS4
//router.post("/API/ABM_ART_Articulos_Reservables/InsertarCompleto", ABM_ART_Articulos_Reservables_Insertar)
//NEFTIS4
//router.put("/API/ABM_ART_Articulos_Reservables/ModificarCompleto", ABM_ART_Articulos_Reservables_Modificar)
*/